export default {
  partNoPlaceholder: 'Teile-Nr. auswählen',
};
